import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: '',
    video: 'relative h-full w-auto',
    closeButton:
      'absolute top-6 right-6 left-auto xl:right-auto xl:left-[calc(100%+24px)]'
  }
});
